import { Component } from '@angular/core';
import { MessageService } from 'primeng/api';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { ToolBarComponent } from "../../components/tool-bar/tool-bar.component";
import { CreateDepartmentComponent } from "../../components/department/create-department/create-department.component";
import { DeleteDepartmentComponent } from "../../components/department/delete-department/delete-department.component";
import { UsersService } from 'src/app/private/services/users.service';

@Component({
  selector: 'app-department-configuration',
  standalone: true,
  imports: [SharedModule, ToolBarComponent, CreateDepartmentComponent, DeleteDepartmentComponent],
  templateUrl: './department-configuration.component.html',
  styleUrl: './department-configuration.component.scss'
})
export class DepartmentConfigurationComponent {
  dataSource: any[] = [];
  totalRecords: number = 0;
  rows: number = 10;
  initialLoad: boolean = true;
  loading: boolean = false;
  filterArray: any[] = [];
  isAddDepartment: boolean = false;
  isEditDepartment: boolean = false;
  isDeleteDepartment: boolean = false;
  departmentData: any;

  columns: any[] = [
    { field: 'name', header: 'Department Name', sortable: true },
    { field: 'code', header: 'Department Code', sortable: true },
    { field: 'head_user.fname', header: 'Head of Department', type: 'user' },
    { field: 'email', header: 'Email', sortable: true },
    { field: 'contact_number', header: 'Contact', sortable: true },
    { field: 'status', header: 'Status', sortable: true },
    { field: 'actions', header: 'Actions', type: 'actions' }
  ];

  allUsers: any[] = [];

  departmentActionItems: any[] = [
    {
      label: 'Options',
      items: [
        {
          label: 'Edit Department',
          icon: 'pi pi-fw pi-pencil',
          command: () => {
            this.isEditDepartment = true;
          }
        },
        {
          label: 'Delete Department',
          icon: 'pi pi-fw pi-trash',
          styleClass: 'delete-menu-item',
          command: () => {
            this.isDeleteDepartment = true;
          }
        }
      ]
    }
  ];

  constructor(
    private api: UsersService,
    private localStorage: LocalStorageService,
    private messageService: MessageService
  ) { }

  ngOnInit() {
    this.loadData({ first: 0, rows: this.rows });
    this.getAllUsers();
  }

  getAllUsers() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
    };
    this.api.findAllUsers(param).subscribe({
      next: (res: any) => {
        this.allUsers = res || [];
        this.allUsers = this.allUsers.map((user: any) => {
          return {
            label: user.fname + " " + user.lname,
            value: user?.user_id
          };
        }
        );
      },
      error: (e: any) => {
        console.error(e);
      },
    });
  }
  loadData(event: any) {
    const page = event.first || 0;
    const size = event.rows || this.rows;

    const param = {
      "where": {
        "organization_id": this.localStorage.getOrganizationId(),
        "campus_id": this.localStorage.getCampusId()
      },
      "filter": null,
      "page": page,
      "limit": size,
      "order": {
        "col": "\"department\".\"updatedAt\"",
        "dir": "DESC"
      }
    }

    this.loading = true;

    this.api.getAllDepartmentsWithCount(param).subscribe({
      next: (data) => {
        this.dataSource = data.rows || [];
        this.totalRecords = data.count || 0;
        this.loading = false;
      },
      error: () => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to load departments.' });
        this.initialLoad = false;
        this.loading = false;
      },
    });
  }

  setDepartmentData(rowData: any) {
    this.departmentData = rowData;
  }

  handleAddDepartment() {
    this.isAddDepartment = true;
  }

  reloadData() {
    this.loadData({ first: 0, rows: this.rows });
  }

  getFullName(user:any) {
    return [user?.prefix, user?.fname, user?.lname]
      .filter(name => !!name)
      .map(name => name.charAt(0).toUpperCase() + name.slice(1).toLowerCase())
      .join(' ');
  }
}
